var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-page-v2"},[_c('div',{staticClass:"page-hero-small"},[_c('h1',[_vm._v(_vm._s(_vm.$t('common.cases')))])]),_c('div',{staticClass:"container-v2 page-body-v2"},[_c('SubNavV2',{attrs:{"items":_vm.navItems}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }